import { render } from "./LeaveRequest.vue?vue&type=template&id=4a6fef18&scoped=true"
import script from "./LeaveRequest.vue?vue&type=script&lang=js"
export * from "./LeaveRequest.vue?vue&type=script&lang=js"

import "./LeaveRequest.vue?vue&type=style&index=0&id=4a6fef18&lang=scss&scoped=true"

import exportComponent from "/var/www/html/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a6fef18"]])

export default __exports__